import { WorkflowsPage } from "@/pages/SetupWorkflow";
import { useUpdateFeatureFlagsContext } from "@hooks";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SetupPage } from "src/pages/Setup";
import { RoutesGuard } from "./routesGuard";

const AppRouter = () => {
  useUpdateFeatureFlagsContext();

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<RoutesGuard />}>
          <Route path="/setup">
            <Route
              path=":setupId/workflows/:step"
              element={<WorkflowsPage />}
            />
            <Route index element={<SetupPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
